var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ActivatedRouteSnapshot } from '@angular/router';
import { Location } from '@angular/common';
import { DwTabRouteReuseService } from '@webdpt/framework';
var FxTabRouteReuseService = /** @class */ (function (_super) {
    __extends(FxTabRouteReuseService, _super);
    function FxTabRouteReuseService(location) {
        return _super.call(this, location) || this;
    }
    FxTabRouteReuseService.prototype.shouldReuseRoute = function (future, curr) {
        var flag = true;
        if (future.params.hasOwnProperty('routeKey') && curr.params.hasOwnProperty('routeKey')) {
            flag = future.params.routeKey === curr.params.routeKey;
        }
        // if (future.routeConfig && future.routeConfig.path === 'shopping-cart') {
        //   return false;
        // }
        // if ((future as any)._urlSegment.segments.map(seg => (seg.path)).join('/') === 'mall/shopping-cart') {
        //   return false;
        // }
        if (future.routeConfig && future.routeConfig.data && future.routeConfig.data.reload) {
            return false;
        }
        return (future.routeConfig === curr.routeConfig) && flag;
    };
    return FxTabRouteReuseService;
}(DwTabRouteReuseService));
export { FxTabRouteReuseService };
